import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-daterange', 'TODAY', 'Today');
Labels.set('ui-daterange', 'YESTERDAY', 'Yesterday');
Labels.set('ui-daterange', 'CURRENT_WEEK', 'Current week');
Labels.set('ui-daterange', 'CURRENT_MONTH', 'Current month');
Labels.set('ui-daterange', 'CURRENT_YEAR', 'Year to date');
Labels.set('ui-daterange', 'PREV_YEAR', 'Last year');
Labels.set('ui-daterange', 'PREV_WEEK', 'Last week');
Labels.set('ui-daterange', 'PREV_MONTH', 'Previous month');
Labels.set('ui-daterange', 'PREV_MONTH_TODAY', 'Last month and this month');
Labels.set('ui-daterange', 'PERIOD_START', 'Period start');
Labels.set('ui-daterange', 'PERIOD_END', 'Period end');
Labels.set('ui-daterange', 'TIME_START', 'Time start');
Labels.set('ui-daterange', 'TIME_END', 'Time end');
Labels.set('ui-daterange', 'CHOOSE_DATE_START', 'Choose start date');
Labels.set('ui-daterange', 'CHOOSE_DATE_END', 'Choose end date');
